import AttendanceSerializer from './base';

export default class ResponseActivityConfiguration extends AttendanceSerializer {}
